// This is just an example,
// so you can safely delete all default props below

import date from './date'

export default {
  date
}
